import axios, { AxiosPromise, CancelTokenSource } from 'axios';
import httpClient from '../../common/api/httpClient';
import urlRoute from '../../common/service/urlRoute';
import { API } from '../constants/api';
import IDeal from '../../common/model/IDeal';
import { ICarDetails } from '../../../../common/model/ICarDetails';

let dealConfigureSource: null | CancelTokenSource = null;

const dealApi = {
  get: (): AxiosPromise<IDeal> => httpClient.get(urlRoute.createUrl(API.CURRENT_DEAL_PATH)),
  /**
   * @deprecated
   */
  configure: (currentConfiguration: ICarDetails): AxiosPromise<IDeal> => {
    if (dealConfigureSource) {
      dealConfigureSource.cancel();
    }

    dealConfigureSource = axios.CancelToken.source();

    return httpClient.post(urlRoute.createUrl(API.CONFIGURE_DEAL_PATH), currentConfiguration, {
      cancelToken: dealConfigureSource.token,
    });
  },
  approveCashDeal: (partExchangeId: string = null): AxiosPromise<{ activeDeal: IDeal }> => {
    return httpClient.post(urlRoute.createUrl(API.APPROVE_FINANCE_PATH), {
      formInput: {
        saveDeal: false,
        paymentType: 'cash',
        partExchangeId: partExchangeId,
      },
    });
  },
};

export default dealApi;
